export default __webpack_public_path__ + "static/media/blue.abb53370.svg";